import { ResponsiveValues } from '@sketch/global-styles'

export const PROJECTS_LAYOUT_COLUMNS: ResponsiveValues<number> = [
  1, 1, 2, 2, 2, 3, 4, 5,
]
